import { Toaster as SonnerToaster, type ToasterProps } from 'sonner'

import { THEME_META } from '@/lib/theme/theme-storage'
import { useTheme } from '@/lib/theme/useTheme'

// Sonner aceita `theme: 'light' | 'dark' | 'system'`. Sincronizamos com o
// `data-theme` ativo (VEC-195) lendo o hook reativo — muda junto com o
// resto do app sem reload.
export function Toaster(props: ToasterProps) {
  const [theme] = useTheme()
  const scheme = THEME_META[theme].scheme

  return (
    <SonnerToaster
      theme={scheme}
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-popover group-[.toaster]:text-popover-foreground group-[.toaster]:border-border group-[.toaster]:shadow-elevated',
          description: 'group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  )
}

export { toast } from 'sonner'
